import { CSSProgressiveBody02 } from "@caisy/league";
import styled from "styled-components";

export const SCreateProjectModalFirstStepItemDescription = styled.div`
  ${CSSProgressiveBody02};
  color: var(--text-04);
  width: 100%;
`;
